import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Header from './Header';
import Main from './Main';
import Login from './Login';

class App extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    loggedIn: false,
	    username: "",
	    userid: "",
	    level: "",
	    token: ""
	};

	this.loggedIn = this.loggedIn.bind(this);
	this.loggedOut = this.loggedOut.bind(this);
    }

    loggedIn(credentials) {
	this.setState({
	    loggedIn: true,
	    username: credentials.username,
	    userid: credentials.userid,
	    level: credentials.level,
	    token: credentials.token
	});
    }

    loggedOut() {
	this.setState({
	    loggedIn: false,
	    userid: "",
	    level: "",
	    token: ""
	});
    }

    render() {
	return (
	    <Container>
		<Row>
		    <Col>
			<Header />
		    </Col>
		</Row>
		<Row>
		    <Col>
			{this.state.loggedIn ?
			 <Main username={this.state.username} userid={this.state.userid} level={this.state.level} token={this.state.token} onLoggedOut={this.loggedOut} /> :
			 <Login onLoggedIn={this.loggedIn} />
			}
		    </Col>
		</Row>
	    </Container>
	);
    }
}

export default App;
